/* TINOR "wrong country?" pop-up: asks Shopify where the visitor is and offers that country's store. */
(function () {
  var KEY = 'tinor:market-suggest';

  /* Country switchers (menu drawer, footer): return to the same page, close on outside click,
     and count a manual pick as an answer so the pop-up below never asks. */
  document.querySelectorAll('[data-cswitch]').forEach(function (form) {
    var ret = form.querySelector('[data-cswitch-return]');
    if (ret) ret.value = location.pathname + location.search;
    form.addEventListener('submit', function (e) {
      var code = e.submitter && e.submitter.value;
      try { localStorage.setItem(KEY, 'switch:' + (code || '')); } catch (_) {}
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.cswitch__details[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.cswitch__details[open]').forEach(function (d) { d.open = false; d.querySelector('summary').focus(); });
  });

  var root = document.querySelector('[data-market-suggest]');
  if (!root) return;

  var current = root.dataset.current;
  var countries = {};
  try { countries = JSON.parse(document.querySelector('[data-market-countries]').textContent); } catch (_) { return; }

  function seen() { try { return localStorage.getItem(KEY); } catch (_) { return null; } }
  function remember(v) { try { localStorage.setItem(KEY, v); } catch (_) {} }

  // A choice made earlier (stay or switch) is respected; switching away by hand also counts.
  if (seen()) return;

  // "the United States", "the Netherlands", but "Canada".
  var THE = { US: 1, GB: 1, NL: 1, AE: 1, PH: 1, CZ: 1 };
  function label(code, name) { return (THE[code] ? 'the ' : '') + name; }
  // All euro countries share one store: "Europe".
  function store(code) { return countries[code].currency === 'EUR' ? 'Europe' : label(code, countries[code].name); }

  function open(code) {
    var c = countries[code];
    root.querySelectorAll('[data-msug-country]').forEach(function (el) {
      el.textContent = label(code, c.name);
    });
    root.querySelectorAll('[data-msug-store]').forEach(function (el) { el.textContent = store(code); });
    root.querySelector('[data-msug-currency]').textContent = c.currency + ' (' + c.symbol + ')';
    root.querySelector('[data-msug-cur]').textContent = 'Shop in ' + c.currency;
    if (countries[current]) root.querySelector('[data-msug-here]').textContent = store(current);
    root.querySelector('[data-msug-code]').value = code;
    var ret = root.querySelector('[name="return_to"]');
    if (ret) ret.value = location.pathname + location.search;

    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      document.body.classList.add('no-scroll');
      var go = root.querySelector('.msug__go');
      if (go && window.matchMedia('(pointer:fine)').matches) go.focus({ preventScroll: true });
    });
  }

  function close() {
    remember('stay:' + current);
    root.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { root.hidden = true; }, 300);
  }

  root.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  root.querySelector('[data-msug-form]').addEventListener('submit', function () {
    remember('switch:' + root.querySelector('[data-msug-code]').value);
  });

  fetch('/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(current), { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var code = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      // Same store already (e.g. a German visitor on the Europe store): nothing to suggest.
      if (!code || code === current || !countries[code]) return;
      if (countries[current] && countries[code].currency === countries[current].currency) return;
      // Let the page settle first; don't stack on top of another open drawer or modal.
      (function show() {
        if (document.querySelector('.drawer.is-open, .modal.is-open, .search-drop.is-open, .mega.is-open')) return setTimeout(show, 3000);
        open(code);
      })();
    })
    .catch(function () {});
})();
